(function () {
  function initIconsCarousel(root) {
    var grid = root.querySelector('[data-yki-grid]');
    var track = root.querySelector('[data-yki-progress-track]');
    var bar = root.querySelector('[data-yki-progress-bar]');
    if (!grid || !track || !bar) return;

    var cards = grid.querySelectorAll('.yki-item');
    if (cards.length <= 1) {
      track.style.display = 'none';
      return;
    }

    bar.style.width = (100 / cards.length) + '%';

    var ticking = false;

    function updateBar() {
      var maxScroll = grid.scrollWidth - grid.clientWidth;
      var ratio = 0;
      if (maxScroll > 0) {
        ratio = Math.abs(grid.scrollLeft) / maxScroll;
        ratio = Math.min(1, Math.max(0, ratio));
      }
      var trackWidth = track.clientWidth;
      var barWidth = bar.clientWidth;
      var maxOffset = trackWidth - barWidth;
      // scrollLeft ratio 0 = first (rightmost/start) card in this RTL layout,
      // so the bar starts hugging the track's right edge and moves left as ratio grows.
      bar.style.right = (ratio * maxOffset) + 'px';
      ticking = false;
    }

    grid.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(updateBar);
          ticking = true;
        }
      },
      { passive: true }
    );

    updateBar();
  }

  function initAll() {
    document.querySelectorAll('.yki-section').forEach(initIconsCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.yki-section');
    if (section) initIconsCarousel(section);
  });
})();
